import { useCallback, useEffect, useState } from "react";
import { createEmptyProblemContext, getProblemContext } from "../services/problem_context_service";

export default function useProblemContext(problemId) {
	const [context, setContext] = useState(createEmptyProblemContext());
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const refresh = useCallback(async () => {
		if (!problemId) {
			setContext(createEmptyProblemContext());
			setError("");
			return;
		}

		setLoading(true);
		setError("");

		try {
			const nextContext = await getProblemContext(problemId);
			setContext(nextContext);
		} catch (nextError) {
			setError(nextError?.message || "Failed to load problem context");
			setContext(createEmptyProblemContext());
		} finally {
			setLoading(false);
		}
	}, [problemId]);

	useEffect(() => {
		let isCancelled = false;

		async function loadContext() {
			if (!problemId) {
				setContext(createEmptyProblemContext());
				setError("");
				return;
			}

			setLoading(true);
			setError("");

			try {
				const nextContext = await getProblemContext(problemId);
				if (isCancelled) {
					return;
				}
				setContext(nextContext);
			} catch (nextError) {
				if (isCancelled) {
					return;
				}
				setError(nextError?.message || "Failed to load problem context");
				setContext(createEmptyProblemContext());
			} finally {
				if (!isCancelled) {
					setLoading(false);
				}
			}
		}

		loadContext();

		return () => {
			isCancelled = true;
		};
	}, [problemId]);

	return {
		context,
		loading,
		error,
		refresh,
	};
}
